define('models/distributor_product',['require','backbone','models/product'],function(request){

    var Backbone = require("backbone");

    var ProductModel = require('models/product');

    return Backbone.Model.extend({
        url : function (){
            // set the endpoint for restful api for distributor products
            return this.id ? (App.Config.apiBase + 'distributor-products/' + this.id + '/')
                            : (App.Config.apiBase + 'distributor-products/');
        },
        defaults : function () {
            return {
                id : null,
                product : new ProductModel().attributes,
                count : 0,
                total_count: 0
            };
        }
    });
});
